import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { Column } from 'further-ui/components/Layout';
import RadioButtons from 'further-ui/components/RadioButtons';

type Props = {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: Array<{
    value: string;
    label: string;
  }>;
};

const FormRadioButtons: FC<Props> = ({ label, ...rest }) => {
  return (
    <Column spacing="sm">
      <Typography variant="h6" color="grey.600">
        {label}
      </Typography>
      <RadioButtons direction="row" optionSpacing="xs" {...rest} />
    </Column>
  );
};

export default FormRadioButtons;
